import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupProduct = () => {
  //page hook
  const { t } = useTranslation();
  return {
    productName: Yup.string().required(
      t("validation.required", {
        productName: t("page.product_name"),
      })
    ),
    mainGroup: Yup.string().required(
      t("validation.required", {
        mainGroup: t("page.main_group"),
      })
    ),
    subGroup: Yup.string().required(
      t("validation.required", {
        subGroup: t("page.sub_group"),
      })
    ),
    sku: Yup.string().required(
      t("validation.required", {
        sku: t("page.sku"),
      })
    ),
    strengthValue: Yup.string().required(
      t("validation.required", {
        strengthValue: t("page.strength_value"),
      })
    ),
    category: Yup.string().required(
      t("validation.required", {
        category: t("page.category"),
      })
    ),
    subCategory: Yup.string().required(
      t("validation.required", {
        subCategory: t("page.sub_category"),
      })
    ),
    packageSize: Yup.number().required(
      t("validation.required", {
        packageSize: t("page.package_size"),
      })
    ),
    authorizedDistributer: Yup.string().required(
      t("validation.required", {
        authorizedDistributer: t("page.package_size"),
      })
    ),
    minPruchaseQty: Yup.number().required(
      t("validation.required", {
        minPruchaseQty: t("page.package_size"),
      })
    ),
    purchaseIncreaseCount: Yup.number().required(
      t("validation.required", {
        purchaseIncreaseCount: t("page.package_size"),
      })
    ),
    sellingUnit: Yup.string().required(
      t("validation.required", {
        sellingUnit: t("page.package_size"),
      })
    ),
    sellingPrice: Yup.number().required(
      t("validation.required", {
        sellingPrice: t("page.package_size"),
      })
    ),
    manufacturerName: Yup.string().required(
      t("validation.required", {
        manufacturerName: t("page.package_size"),
      })
    ),
    madeInCountry: Yup.string().required(
      t("validation.required", {
        madeInCountry: t("page.package_size"),
      })
    ),
    chemicalName: Yup.string().required(
      t("validation.required", {
        chemicalName: t("page.package_size"),
      })
    ),
    actionAndIndication: Yup.string().required(
      t("validation.required", {
        actionAndIndication: t("page.package_size"),
      })
    ),
    dosage: Yup.string().required(
      t("validation.required", {
        dosage: t("page.package_size"),
      })
    ),
    potentialSideEffect: Yup.string().required(
      t("validation.required", {
        potentialSideEffect: t("page.package_size"),
      })
    ),
    productDescription: Yup.string().required(
      t("validation.required", {
        productDescription: t("page.package_size"),
      })
    ),
    // productImage: Yup.string().required(
    //   t("validation.required", {
    //     productImage: t("page.package_size"),
    //   })
    // ),
    expiryDate: Yup.string().required(
      t("validation.required", {
        expiryDate: t("page.package_size"),
      })
    ),
  };
};
